// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Configuration,
  BackOfficeOrderControllerApiFactory,
} from '@ce-openapi/order-reporting-service-ts-axios-client';
import { ORDER_REPORTING_SERVICE } from '../orderReporting/constants';

const conf = new Configuration({
  basePath: ORDER_REPORTING_SERVICE,
});

export const getOrderDetail = (id: string): any =>
  BackOfficeOrderControllerApiFactory(conf).backofficeV1OrdersIdGet(id);
